<app-loading *ngIf="contentReady"></app-loading>

<div class="bb-page" *ngIf="!contentReady">
  <div class="bb-page-shell">

    <!-- Header -->
    <div class="bb-page-header">
      <div class="bb-page-title-block">
                                 <span class="bb-eyebrow">{{ 'clientsbookings' | transloco }}</span>
        <h2 class="bb-page-title">{{ "clientsbookings" | transloco }}</h2>
        <p class="bb-page-subtitle">{{ "manage bookings" | transloco }}</p>
      </div>

      <div class="bb-header-actions">
        <button class="bb-btn bb-btn-primary" type="button" routerLink="/booking">
          {{ "add booking" | transloco }}
        </button>
      </div>
    </div>

    <!-- Search Card -->
    <div class="bb-filter-card">
      <div class="search-row">
        <div class="search-box">
          <input
            type="text"
            class="bb-input"
            [(ngModel)]="searchKey"
            placeholder="{{ 'phone' | transloco }}"
            (keydown.enter)="onEnterPressed()"
          />

          <button class="bb-btn bb-btn-primary" type="button" (click)="search()">
            {{ "Search" | transloco }}
          </button>

          <button
            *ngIf="searched"
            class="bb-btn bb-btn-secondary"
            type="button"
            (click)="clearSearch()"
          >
            {{ "all data" | transloco }}
          </button>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="bb-table-card" *ngIf="!noData">
      <div class="bb-table-scroll">
        <table
          mat-table
          id="stocktable"
          [dataSource]="dataSource"
          class="bb-table mat-elevation-z0"
        >

          <!-- ID -->
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>
              #
            </th>
            <td mat-cell *matCellDef="let element">
              <strong class="bb-text-navy">#{{ element.id }}</strong>
            </td>
          </ng-container>

          <!-- Client -->
          <ng-container matColumnDef="client">
            <th mat-header-cell *matHeaderCellDef>
              {{ "client" | transloco }}
            </th>
            <td mat-cell *matCellDef="let element">
              <div class="bb-text-stack">
                <strong class="bb-product-title">{{ getClientName(element) }}</strong>
                <small *ngIf="element.user?.email">{{ element.user.email }}</small>
              </div>
            </td>
          </ng-container>

          <!-- Phone -->
          <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef>
              {{ "phone" | transloco }}
            </th>
            <td mat-cell *matCellDef="let element">
              <a
                *ngIf="getPhone(element) !== '—'; else noPhone"
                [href]="'tel:' + getPhone(element)"
                class="bb-link-action bb-inline-flex"
              >
                {{ getPhone(element) }}
              </a>

              <ng-template #noPhone>—</ng-template>
            </td>
          </ng-container>

          <!-- Service -->
          <ng-container matColumnDef="service">
            <th mat-header-cell *matHeaderCellDef>
              {{ "service" | transloco }}
            </th>
            <td mat-cell *matCellDef="let element">
              <strong class="bb-text-navy">{{ getBookingServiceName(element) }}</strong>
            </td>
          </ng-container>

          <!-- Pet -->
          <ng-container matColumnDef="pet">
            <th mat-header-cell *matHeaderCellDef>
              {{ "pet" | transloco }}
            </th>
            <td mat-cell *matCellDef="let element">
              <span *ngIf="element.pet_type; else noPetType" class="bb-badge bb-badge-soft-blue">
                {{ getPetTypeLabel(element.pet_type) | transloco }}
              </span>

              <ng-template #noPetType>—</ng-template>
            </td>
          </ng-container>

          <!-- Booking Date -->
          <ng-container matColumnDef="booking_date">
            <th mat-header-cell *matHeaderCellDef>
              {{ "Booking Date" | transloco }}
            </th>
            <td mat-cell *matCellDef="let element">
              <span class="bb-text-muted bb-font-semibold">
                {{ formatDateTimeView(element.booking_date) }}
              </span>
            </td>
          </ng-container>

          <!-- Status -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>
              {{ "status" | transloco }}
            </th>
            <td mat-cell *matCellDef="let element">
              <span class="bb-badge booking-status" [ngClass]="getStatusClass(element.status)">
                {{ getStatusLabel(element.status) | transloco }}
              </span>
            </td>
          </ng-container>

          <!-- Deferred Date -->
          <ng-container matColumnDef="deferred_booking_date">
            <th mat-header-cell *matHeaderCellDef>
              {{ "Deferred Date" | transloco }}
            </th>
            <td mat-cell *matCellDef="let element">
              <span class="bb-text-muted bb-font-semibold">
                {{ formatDateTimeView(element.deferred_booking_date) }}
              </span>
            </td>
          </ng-container>

          <!-- Website -->
          <ng-container matColumnDef="website">
            <th mat-header-cell *matHeaderCellDef>
              {{ "website_link" | transloco }}
            </th>
            <td mat-cell *matCellDef="let element">
              <span class="bb-badge bb-badge-soft-cyan">
                {{ element.from_website || "website" }}
              </span>
            </td>
          </ng-container>

          <!-- Actions -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="bb-actions-th"></th>

            <td mat-cell *matCellDef="let element" class="bb-actions-td">
              <div class="dropdown bb-action-dropdown" *ngIf="hasBookingActions(element)">
                <button
                  class="bb-icon-btn action-btn menu"
                  type="button"
                  data-bs-toggle="dropdown"
                  data-bs-boundary="viewport"
                  aria-expanded="false"
                  title="{{ 'Actions' | transloco }}"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <circle cx="12" cy="5" r="2" />
                    <circle cx="12" cy="12" r="2" />
                    <circle cx="12" cy="19" r="2" />
                  </svg>
                </button>

                <ul class="dropdown-menu dropdown-menu-end bb-dropdown-menu">

                  <ng-container *ngIf="!isFinalStatus(element.status)">

                    <li *ngIf="shouldShowStatusAction(element.status, 1)">
                      <button
                        class="dropdown-item bb-dropdown-item"
                        type="button"
                        [disabled]="isUpdatingStatus"
                        (click)="setBookingStatus(element, 1)"
                      >
                        {{ "approved" | transloco }}
                      </button>
                    </li>

                    <li *ngIf="shouldShowStatusAction(element.status, 4)">
                      <button
                        class="dropdown-item bb-dropdown-item"
                        type="button"
                        [disabled]="isUpdatingStatus"
                        (click)="setBookingStatus(element, 4)"
                      >
                        {{ "completed" | transloco }}
                      </button>
                    </li>

                    <li *ngIf="!isStatus(element.status, 3)">
                      <button
                        class="dropdown-item bb-dropdown-item"
                        type="button"
                        [disabled]="isUpdatingStatus"
                        (click)="openDeferredDatePopup(element)"
                      >
                        {{ "deferred" | transloco }}
                      </button>
                    </li>

                    <li *ngIf="isStatus(element.status, 3)">
                      <button
                        class="dropdown-item bb-dropdown-item"
                        type="button"
                        [disabled]="isUpdatingStatus"
                        (click)="openDeferredDatePopup(element)"
                      >
                        {{ "Change Deferred Date" | transloco }}
                      </button>
                    </li>

                    <li *ngIf="shouldShowStatusAction(element.status, 2)">
                      <button
                        class="dropdown-item bb-dropdown-item"
                        type="button"
                        [disabled]="isUpdatingStatus"
                        (click)="setBookingStatus(element, 2)"
                      >
                        {{ "rejected" | transloco }}
                      </button>
                    </li>

                    <li>
                      <hr class="dropdown-divider">
                    </li>

                  </ng-container>

                  <li *ngIf="!isSubAdmin">
                    <button
                      class="dropdown-item bb-dropdown-item text-danger"
                      type="button"
                      [disabled]="isUpdatingStatus"
                      (click)="deleteBooking(element.id)"
                    >
                      {{ "Delete" | transloco }}
                    </button>
                  </li>

                </ul>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns" class="mat-header-row-custom"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="mat-row-custom"></tr>
        </table>
      </div>

      <mat-paginator
        *ngIf="total > 0 && !noData"
        class="bb-paginator"
        [length]="total"
        [pageIndex]="page - 1"
        [pageSize]="perPage"
        [pageSizeOptions]="[10, 20, 50, 100]"
        showFirstLastButtons
        (page)="pageChanged($event)"
      >
      </mat-paginator>
    </div>

    <div class="bb-empty-state" *ngIf="noData">
      <app-nodata></app-nodata>
    </div>

  </div>
</div>

<!-- Deferred Date Popup -->
<div *ngIf="showDeferredPopup" class="bb-modal-backdrop">
  <div class="bb-modal-card bb-modal-sm">

    <div class="bb-modal-header">
      <h4>{{ "Change Deferred Date" | transloco }}</h4>

      <button
        type="button"
        class="bb-modal-close"
        (click)="closeDeferredPopup()"
        [disabled]="isUpdatingStatus"
      >
        ✕
      </button>
    </div>

    <div class="bb-field">
      <label class="bb-label">
        {{ "Deferred Date" | transloco }}
      </label>

      <input
        class="bb-input"
        type="datetime-local"
        [(ngModel)]="deferredBookingDate"
        [min]="todayDateTime"
      />
    </div>

    <div class="bb-modal-actions">
      <button
        type="button"
        class="bb-btn bb-btn-secondary"
        (click)="closeDeferredPopup()"
        [disabled]="isUpdatingStatus"
      >
        {{ "close" | transloco }}
      </button>

      <button
        type="button"
        class="bb-btn bb-btn-primary"
        (click)="submitDeferredDate()"
        [disabled]="isUpdatingStatus || !deferredBookingDate"
      >
        <span *ngIf="!isUpdatingStatus">
          {{ "Submit" | transloco }}
        </span>

        <span *ngIf="isUpdatingStatus">
          {{ "Loading..." | transloco }}
        </span>
      </button>
    </div>

  </div>
</div>
